import React from 'react'

import { InlineAlert, styled } from '@driftt/dds'

const StyledInlineAlert = styled(InlineAlert, {
  marginBottom: '24px',
})

const OrgWideWarning = () => {
  return (
    <StyledInlineAlert
      title="This meeting type is shared with your organization. Changes will affect all teammates."
      description="We suggest using personalization tags to deliver the best experience for your teammates' guests."
      variant="warning"
    />
  )
}

export default OrgWideWarning
